import React, {FC} from 'react';

const ThoughtBalloon: FC<React.HTMLAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg width="49" height="51" viewBox="0 0 49 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.2221 0.0322583C14.9257 -0.422725 11.8559 4.04783 10.9831 6.33998C9.56674 5.40933 3.52264 5.28525 0.755866 11.2C-2.01091 17.1148 3.50623 24.6255 6.24007 26.2455C4.5273 27.5725 1.16965 30.7161 4.15017 35.2418C6.51246 38.8287 11.9564 37.0708 15.9238 35.2418C16.4343 37.2926 19.5601 41.3117 27.979 40.9808C36.3979 40.6499 38.832 34.6386 38.9967 31.6743C41.747 32.536 47.5539 32.9565 48.7792 27.7449C50.0045 22.5333 45.8313 20.1618 43.5915 19.6276C44.3162 17.4561 44.718 12.0376 40.5283 7.73596C36.3386 3.4343 30.647 4.53039 28.3248 5.61615C27.8308 3.94443 25.5185 0.487242 20.2221 0.0322583Z"
        fill="white"
      />
      <circle cx="6" cy="47" r="4" fill="white" />
    </svg>
  );
};

export default ThoughtBalloon;
